import { render, staticRenderFns } from "./radio-button-group.vue?vue&type=template&id=4ab9c57a&scoped=true"
import script from "./radio-button-group.vue?vue&type=script&setup=true&lang=ts"
export * from "./radio-button-group.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./radio-button-group.vue?vue&type=style&index=0&id=4ab9c57a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab9c57a",
  null
  
)

export default component.exports